import { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Button, Card } from '@mui/material';

import { motion } from 'framer-motion';
import { ListGroup } from 'react-bootstrap';
import { preguntasEmpresa, preguntasBDE, preguntasFrecuentes } from '../preguntas-cda';
import { ModalQuestion } from './ModalQuestion';


function ContentQuestions() {
  const [showAll, setShowAll] = useState(false);
  const displayedQuestions = showAll ? preguntasFrecuentes : preguntasFrecuentes.slice(0, 5);
  const [question, setQuestion] = useState(null);
  const [mostrarModalQuestion, setMostrarModalQuestion] = useState(false);

  const abrirModalQuestion = (pregunta) => { setMostrarModalQuestion(true); setQuestion(pregunta) };
  const cerrarModalQuestion = () => setMostrarModalQuestion(false);

  const [mostrarPreguntas, setMostrarPreguntas] = useState({
    seccion1: false, seccion2: false, seccion3: false,
  });

  const toggleMostrarPreguntas = (seccion) => {
    setMostrarPreguntas((prevState) => ({
      ...prevState,
      [seccion]: !prevState[seccion],
    }));
  };

  const secciones = [
    {
      id: 1,
      nombre: 'Buscadores de empleo',
      preguntas: preguntasBDE,
    },
    {
      id: 2,
      nombre: 'Empresas',
      preguntas: preguntasEmpresa,
    },
  ];

  return (
    <Container className='container'>
      <Header>
        <Title>Preguntas Frecuentes</Title>
        <ShowMoreButton onClick={() => setShowAll(!showAll)}>
          {showAll ? 'Ver menos' : 'Ver más'}
        </ShowMoreButton>
      </Header>
      <FaqSection className='pb-5'>
        {displayedQuestions.map((pregunta) => (
          <FaqItem key={pregunta.id}>
            <Link onClick={() => abrirModalQuestion(pregunta)} style={{ textDecoration: 'none' }}>
              {pregunta.pregunta}
            </Link>
          </FaqItem>
        ))}
      </FaqSection>
      <Header className='pt-4'>
        <Title>Ayuda por secciones</Title>
      </Header>
      <FaqSection>
        <div className="row">
          {secciones.map((seccion) => (
            <div className="col-sm-12 col-md-12 col-lg-6 py-2 px-2" key={seccion.id}>
              <Card className="p-2 m-2">
                <div className="text-center font22 pb-3 pt-2"><strong>{seccion.nombre}</strong></div>
                <ListGroup variant="flush" className="px-2 pb-4" style={{ border: 'none' }}>
                  {mostrarPreguntas[`seccion${seccion.id}`] ? seccion.preguntas.map((pregunta) => (
                    <motion.div whileHover={{ scale: 1.05 }} key={pregunta.id}>
                      <Link onClick={() => abrirModalQuestion(pregunta)} style={{ textDecoration: 'none' }}>
                        <ListGroup.Item style={{ border: 'none' }}>{pregunta.pregunta}</ListGroup.Item>
                      </Link>
                    </motion.div>
                  )) : seccion.preguntas.slice(0, 5).map((pregunta) => (
                    <motion.div whileHover={{ scale: 1.05 }} key={pregunta.id}>
                      <Link onClick={() => abrirModalQuestion(pregunta)} style={{ textDecoration: 'none' }}>
                        <ListGroup.Item style={{ border: 'none' }}>{pregunta.pregunta}</ListGroup.Item>
                      </Link>
                    </motion.div>
                  ))}
                  <div className="pt-3 text-center">
                    <Button variant='contained' onClick={() => toggleMostrarPreguntas(`seccion${seccion.id}`)}>
                      {mostrarPreguntas[`seccion${seccion.id}`] ? 'Ocultar artículos' : 'Ver todas las preguntas'}
                    </Button>
                  </div>
                </ListGroup>
              </Card>
            </div>
          ))}
        </div>
      </FaqSection>
      <ModalQuestion mostrarModalQuestion={mostrarModalQuestion} cerrarModalQuestion={cerrarModalQuestion} question={question} />
    </Container>
  );
}

export default ContentQuestions;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding-top: 160px;
  padding-bottom: 40px;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 90%;
  padding: 1rem 0rem;
`;

const Title = styled.h2`
  margin: 0;
`;

const FaqSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  gap: 10px;
  padding: 1rem 2rem;
  margin-bottom: 40px;
  @media (max-width: 960) {
   padding: 0;
  }
`;

const FaqItem = styled.div`
  background-color: #f0f0f0;
  padding: 8px 12px;
  border-radius: 15px;
  cursor: pointer;
  font-size: 0.9rem;
  &:hover {
    background-color: #e0e0e0;
  }
  a {
    text-decoration: none;
    color: black;
    font-weight: normal;
  }
`;

const ShowMoreButton = styled.button`
  background: none;
  border: none;
  color: #007bff;
  cursor: pointer;
  font-size: 1rem;
  &:hover {
    text-decoration: underline;
  }
`;
